import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import logo from "./Images/logo_page.jpg";
import Button from "@mui/material/Button";

import "./css/Header.css";

export const Header = () => {
  const navigate = useNavigate();
  const [state, setState] = useState(false);

  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 767;
      setIsMobile(isMobile);
      if (!isMobile) {
        setState(false); // Hide the drawer on larger screens
      }
    };

    handleResize();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsHeaderActive(true);
    } else {
      setIsHeaderActive(false);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  const list = () => (
    <Box
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      className="md:flex"
    >
      <List>
        {["Home", "About", "Service"].map((text, index) => {
          const id = `section-${index + 1}`;

          const scrollToSection = () => {
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
            toggleDrawer(false)();
          };

          return (
            <ListItem key={id} disablePadding>
              <ListItemButton
                component={RouterLink}
                to={`#${id}`}
                onClick={scrollToSection}
              >
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider className="none" />

      <div
        className="Register px-4 py-8"
        onClick={() => {
          navigate("/membership");
        }}
      >
        <Button variant="contained">Register</Button>
      </div>
    </Box>
  );

  const renderDrawer = () => (
    <Drawer
      anchor="right"
      open={state}
      onClose={toggleDrawer(false)}
      className="drawer"
    >
      <div className="header flex justify-between items-center p-4">
        <img src={logo} alt="portfolio" className=" w-24" />
        <div onClick={toggleDrawer(false)}>
          <HiOutlineX className="text-3xl text-gray-500" />
        </div>
      </div>

      <div className="drawerBio text-xs px-4 mb-4">
        Your Financial Journey Begins Empowering Dreams, Building Futures.
        Banking Beyond Boundaries
      </div>
      <Divider />
      {list()}
    </Drawer>
  );

  return (
    <>
      <div className="headers">
        <header className={isHeaderActive ? "active" : ""}>
          <div className="headerLogoName">
            <img src={logo} alt="" className="md:py-6" />
            {isMobile ? (
              <>
                <HiOutlineMenu
                  className="menuIcon"
                  onClick={toggleDrawer(true)}
                />
                {renderDrawer()}
              </>
            ) : (
              <div className="section">{list()}</div>
            )}
          </div>
        </header>
      </div>
    </>
  );
};
